import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BACK, LAY } from '@ezugi/constants';

type PrevStakes = Partial<Record<typeof LAY | typeof BACK, number>>;
type KeypadState = Partial<{ prevStakes: PrevStakes }>;

const INITIAL_STATE: KeypadState = {};

const keypadSlice = createSlice({
  name: 'prevStakes',
  initialState: INITIAL_STATE,
  reducers: {
    set(state, { payload }: PayloadAction<PrevStakes>) {
      return {
        ...state,
        prevStakes: {
          ...state.prevStakes,
          ...payload,
        },
      };
    },
  },
});

export const keypadActions = { prevStakes: keypadSlice.actions };

export default keypadSlice.reducer;
